import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=08bf0b03&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=08bf0b03&prod&scoped=true&lang=scss"
import style1 from "./layout.vue?vue&type=style&index=1&id=08bf0b03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf0b03",
  null
  
)

export default component.exports